export default __webpack_public_path__ + "locales/de/People.json?hash=800188742de38ca001df7a18199267b7";